const SystemEventLevel = {
  Trace: {
    id: "TRACE",
    name: "TRACE",
    color: "#939598"
  },
  Debug: {
    id: "DEBUG",
    name: "DEBUG",
    color: "#005aaa"
  },
  Info: {
    id: "INFO",
    name: "INFO",
    color: "#0c9294"
  },
  Warning: {
    id: "WARNING",
    name: "WARNING",
    color: "#fdb813"
  },
  Error: {
    id: "ERROR",
    name: "ERROR",
    color: "#ee2932"
  },
  Critical: {
    id: "CRITICAL",
    name: "CRITICAL",
    color: "#bc1227"
  }
};
const SystemEventLevelArray = Object.values(SystemEventLevel);
const getSystemEventLevelById = (id) => SystemEventLevelArray.find((x) => x.id === id);
export {
  SystemEventLevel,
  SystemEventLevelArray,
  getSystemEventLevelById
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3lzdGVtRXZlbnRMZXZlbC5qcyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0YW50cy9TeXN0ZW1FdmVudExldmVsLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBTeXN0ZW1FdmVudExldmVsID0ge1xuXHRUcmFjZToge1xuXHRcdGlkOiBcIlRSQUNFXCIsXG5cdFx0bmFtZTogXCJUUkFDRVwiLFxuXHRcdGNvbG9yOiBcIiM5Mzk1OThcIixcblx0fSxcblx0RGVidWc6IHtcblx0XHRpZDogXCJERUJVR1wiLFxuXHRcdG5hbWU6IFwiREVCVUdcIixcblx0XHRjb2xvcjogXCIjMDA1YWFhXCIsXG5cdH0sXG5cdEluZm86IHtcblx0XHRpZDogXCJJTkZPXCIsXG5cdFx0bmFtZTogXCJJTkZPXCIsXG5cdFx0Y29sb3I6IFwiIzBjOTI5NFwiLFxuXHR9LFxuXHRXYXJuaW5nOiB7XG5cdFx0aWQ6IFwiV0FSTklOR1wiLFxuXHRcdG5hbWU6IFwiV0FSTklOR1wiLFxuXHRcdGNvbG9yOiBcIiNmZGI4MTNcIixcblx0fSxcblx0RXJyb3I6IHtcblx0XHRpZDogXCJFUlJPUlwiLFxuXHRcdG5hbWU6IFwiRVJST1JcIixcblx0XHRjb2xvcjogXCIjZWUyOTMyXCIsXG5cdH0sXG5cdENyaXRpY2FsOiB7XG5cdFx0aWQ6IFwiQ1JJVElDQUxcIixcblx0XHRuYW1lOiBcIkNSSVRJQ0FMXCIsXG5cdFx0Y29sb3I6IFwiI2JjMTIyN1wiLFxuXHR9LFxufTtcblxuZXhwb3J0IGNvbnN0IFN5c3RlbUV2ZW50TGV2ZWxBcnJheSA9IE9iamVjdC52YWx1ZXMoU3lzdGVtRXZlbnRMZXZlbCk7XG5cbmV4cG9ydCBjb25zdCBnZXRTeXN0ZW1FdmVudExldmVsQnlJZCA9IChpZCkgPT5cblx0U3lzdGVtRXZlbnRMZXZlbEFycmF5LmZpbmQoKHgpID0+IHguaWQgPT09IGlkKTtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBWSxNQUFDLG1CQUFtQjtBQUFBLEVBQy9CLE9BQU87QUFBQSxJQUNOLElBQUk7QUFBQSxJQUNKLE1BQU07QUFBQSxJQUNOLE9BQU87QUFBQSxFQUNQO0FBQUEsRUFDRCxPQUFPO0FBQUEsSUFDTixJQUFJO0FBQUEsSUFDSixNQUFNO0FBQUEsSUFDTixPQUFPO0FBQUEsRUFDUDtBQUFBLEVBQ0QsTUFBTTtBQUFBLElBQ0wsSUFBSTtBQUFBLElBQ0osTUFBTTtBQUFBLElBQ04sT0FBTztBQUFBLEVBQ1A7QUFBQSxFQUNELFNBQVM7QUFBQSxJQUNSLElBQUk7QUFBQSxJQUNKLE1BQU07QUFBQSxJQUNOLE9BQU87QUFBQSxFQUNQO0FBQUEsRUFDRCxPQUFPO0FBQUEsSUFDTixJQUFJO0FBQUEsSUFDSixNQUFNO0FBQUEsSUFDTixPQUFPO0FBQUEsRUFDUDtBQUFBLEVBQ0QsVUFBVTtBQUFBLElBQ1QsSUFBSTtBQUFBLElBQ0osTUFBTTtBQUFBLElBQ04sT0FBTztBQUFBLEVBQ1A7QUFDRjtBQUVZLE1BQUMsd0JBQXdCLE9BQU8sT0FBTyxnQkFBZ0I7QUFFdkQsTUFBQywwQkFBMEIsQ0FBQyxPQUN2QyxzQkFBc0IsS0FBSyxDQUFDLE1BQU0sRUFBRSxPQUFPLEVBQUU7In0=
